import { render, staticRenderFns } from "./FeatureListTable.vue?vue&type=template&id=01039636&scoped=true"
import script from "./FeatureListTable.vue?vue&type=script&lang=js"
export * from "./FeatureListTable.vue?vue&type=script&lang=js"
import style0 from "./FeatureListTable.vue?vue&type=style&index=0&id=01039636&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01039636",
  null
  
)

export default component.exports